import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import type { Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink';
import 'Components/frameworks/dynamic-link/DynamicLink';
import { TextLink } from 'Components/frameworks/text-link/TextLink';
import type { TextSeeMoreProps } from 'Components/frameworks/text-see-more/TextSeeMore';
import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore';
import * as CARD_LAYOUTS from 'Components/frameworks/card/Card.constants';
import { themes } from './CardBody.themes';
type Props = {
  ctaLabel?: string;
  dataTestIdPrefix?: string;
  displayLoadMore?: boolean;
  isTablet?: boolean;
  layout?: keyof typeof CARD_LAYOUTS;
  link?: DynamicLinkProps;
  seeLessLabel?: string;
  seeMoreLabel?: string;
  text?: TextSeeMoreProps;
  theme?: keyof typeof themes;
};
export const CardBody = ({
  ctaLabel,
  dataTestIdPrefix,
  displayLoadMore = true,
  isTablet,
  layout,
  link = {},
  seeLessLabel,
  seeMoreLabel,
  text = {},
  theme = 'default',
}: Props) => {
  const { thCta, thCtaDefaultColor } = themes[theme];
  const isCollapsable =
    displayLoadMore &&
    (!isTablet || [CARD_LAYOUTS.COLUMN_1, CARD_LAYOUTS.COLUMN_2].includes(layout));
  return (
    <Fragment>
      <TextSeeMore
        {...text}
        dataTestIdPrefix={dataTestIdPrefix}
        hasNoScrollOnCollapse
        isCollapseEnabled={isCollapsable}
        seeLessLabel={seeLessLabel}
        seeMoreLabel={seeMoreLabel}
      />
      <TextLink
        {...link}
        className={classnames(thCta, {
          'mt-20': text?.text,
        })}
        color={thCtaDefaultColor}
        iconName={ICONS.ARROW_TAIL_RIGHT}
        label={ctaLabel}
      />
    </Fragment>
  );
};
